export default __webpack_public_path__ + "media/disconnected-dog.b7103f56.svg";